import { render, staticRenderFns } from "./AssignmentsControl.vue?vue&type=template&id=0014afda&scoped=true&"
import script from "./AssignmentsControl.vue?vue&type=script&lang=js&"
export * from "./AssignmentsControl.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsControl.vue?vue&type=style&index=0&id=0014afda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014afda",
  null
  
)

export default component.exports